/*
  ProviderMark — initial-letter chip with a deterministic hue per provider.
  Used in the stream row, event inspector header, and endpoints list.
  Hue is OKLCH (works in light + dark) so the chip is visible without
  inventing a per-provider hex palette.
*/

const HUE_BY_PROVIDER: Record<string, number> = {
  Stripe: 265, GitHub: 240, Shopify: 145, Twilio: 0, SendGrid: 220,
  Slack: 310, PayPal: 230, Linear: 260, Paddle: 200, Discord: 250,
  // lowercase aliases — the backend's `detectProvider` returns lowercase.
  stripe: 265, github: 240, shopify: 145, twilio: 0, slack: 310, paddle: 200,
  sendgrid: 220, paypal: 230, linear: 260, discord: 250,
}

export function ProviderMark({ name, size = 14 }: { name?: string; size?: number }) {
  // Generic webhooks have no detected provider — render nothing rather than a
  // meaningless "?" chip on every stream row.
  if (!name || name === 'generic' || name === 'unknown') return null
  const letter = name[0].toUpperCase()
  // Default hue 120 (green) for providers without a dedicated hue — matches
  // the signal-green register so they still feel "in family".
  const h = HUE_BY_PROVIDER[name] ?? 120
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
      width: size, height: size, borderRadius: 4,
      fontSize: size * 0.6, fontWeight: 600,
      background: `oklch(0.94 0.04 ${h})`,
      color: `oklch(0.32 0.10 ${h})`,
      border: `1px solid oklch(0.88 0.04 ${h})`,
      fontFamily: 'var(--font-mono, ui-monospace, monospace)',
      lineHeight: 1,
    }}>{letter}</span>
  )
}
